import { journeyAction, } from './base';

import { JourneyActionUnAssign as JourneyActionUnAssignBase, } from 'atlas-shared';

export const JourneyActionUnAssign = journeyAction({
  ...JourneyActionUnAssignBase,
  icon: 'UserX',
});
